module.exports = require('./lib/linkify-react').default;



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/react.js
// module id = 714
// module chunks = 0